import { useEffect } from 'react';
import { overlayActions } from '../../store/overlaySlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export function ToastHost() {
  const toasts = useAppSelector((state) => state.overlays.toasts);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const timers = toasts.map((toast) =>
      window.setTimeout(() => dispatch(overlayActions.removeToast(toast.id)), 3200),
    );
    return () => timers.forEach(window.clearTimeout);
  }, [dispatch, toasts]);
  return (
    <div className="toast-host" aria-live="polite">
      {toasts.map((toast) => (
        <div className={`toast toast-${toast.tone}`} key={toast.id}>
          {toast.message}
        </div>
      ))}
    </div>
  );
}
